"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const devextreme_angular_1 = require("devextreme-angular");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const updateDAPAndDACTechOneFacility_service_1 = require("./services/updateDAPAndDACTechOneFacility.service");
const update_dap_dac_techone_facility_component_1 = require("./components/update-dap-dac-techone-facility.component");
const updateDAPAndDACTechOneFacility_states_1 = require("./updateDAPAndDACTechOneFacility.states");
const i0 = require("@angular/core");
const i1 = require("@uirouter/angular-hybrid");
class UpdateDAPAndDACTechOneFacilityModule {
}
exports.UpdateDAPAndDACTechOneFacilityModule = UpdateDAPAndDACTechOneFacilityModule;
UpdateDAPAndDACTechOneFacilityModule.ɵmod = i0.ɵɵdefineNgModule({ type: UpdateDAPAndDACTechOneFacilityModule });
UpdateDAPAndDACTechOneFacilityModule.ɵinj = i0.ɵɵdefineInjector({ factory: function UpdateDAPAndDACTechOneFacilityModule_Factory(t) { return new (t || UpdateDAPAndDACTechOneFacilityModule)(); }, providers: [updateDAPAndDACTechOneFacility_service_1.UpdateDAPAndDACTechOneFacilityService], imports: [[
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            devextreme_angular_1.DxFormModule,
            devextreme_angular_1.DxButtonModule,
            devextreme_angular_1.DxDataGridModule,
            devextreme_angular_1.DxDateBoxModule,
            devextreme_angular_1.DxDropDownBoxModule,
            devextreme_angular_1.DxListModule,
            devextreme_angular_1.DxValidatorModule,
            angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: updateDAPAndDACTechOneFacility_states_1.states })
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UpdateDAPAndDACTechOneFacilityModule, { declarations: [update_dap_dac_techone_facility_component_1.UpdateDAPAndDACTechOneFacilityComponent], imports: [platform_browser_1.BrowserModule,
        forms_1.FormsModule,
        devextreme_angular_1.DxFormModule,
        devextreme_angular_1.DxButtonModule,
        devextreme_angular_1.DxDataGridModule,
        devextreme_angular_1.DxDateBoxModule,
        devextreme_angular_1.DxDropDownBoxModule,
        devextreme_angular_1.DxListModule,
        devextreme_angular_1.DxValidatorModule, i1.UIRouterUpgradeModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UpdateDAPAndDACTechOneFacilityModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    platform_browser_1.BrowserModule,
                    forms_1.FormsModule,
                    devextreme_angular_1.DxFormModule,
                    devextreme_angular_1.DxButtonModule,
                    devextreme_angular_1.DxDataGridModule,
                    devextreme_angular_1.DxDateBoxModule,
                    devextreme_angular_1.DxDropDownBoxModule,
                    devextreme_angular_1.DxListModule,
                    devextreme_angular_1.DxValidatorModule,
                    angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: updateDAPAndDACTechOneFacility_states_1.states })
                ],
                providers: [updateDAPAndDACTechOneFacility_service_1.UpdateDAPAndDACTechOneFacilityService],
                declarations: [
                    update_dap_dac_techone_facility_component_1.UpdateDAPAndDACTechOneFacilityComponent
                ]
            }]
    }], null, null); })();
